const BonusTable = ({}) => {
  return (
    <>
      <div
        className="home-container-all"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="table-wrapper">
          <table class="event-table">
            <thead>
              <tr>
                <th>
                  <div class="" style={{ color: "#b3122f " }}>
                    N° EVENTI
                  </div>
                </th>
                <th>
                  <div class="" style={{ color: "#000000" }}>
                    %
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <div class="cell">5</div>
                </td>
                <td>
                  <div class="cell percent">5%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">6</div>
                </td>
                <td>
                  <div class="cell percent">10%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">7</div>
                </td>
                <td>
                  <div class="cell percent">12%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">8</div>
                </td>
                <td>
                  <div class="cell percent">17%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">9</div>
                </td>
                <td>
                  <div class="cell percent">22%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">10</div>
                </td>
                <td>
                  <div class="cell percent">27%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">11</div>
                </td>
                <td>
                  <div class="cell percent">32%</div>
                </td>
              </tr>

              <tr class="">
                <td>
                  <div class="cell">12</div>
                </td>
                <td>
                  <div class="cell percent">37%</div>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="event-table">
            <thead>
              <tr>
                <th>
                  <div class="" style={{ color: "#b3122f" }}>
                    N° EVENTI
                  </div>
                </th>
                <th>
                  <div class="" style={{ color: "#000000" }}>
                    %
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <div class="cell">14</div>
                </td>
                <td>
                  <div class="cell percent">48%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">15</div>
                </td>
                <td>
                  <div class="cell percent">54%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">16</div>
                </td>
                <td>
                  <div class="cell percent">60%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">17</div>
                </td>
                <td>
                  <div class="cell percent">67%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">18</div>
                </td>
                <td>
                  <div class="cell percent">73%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">19</div>
                </td>
                <td>
                  <div class="cell percent">80%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">20</div>
                </td>
                <td>
                  <div class="cell percent">90%</div>
                </td>
              </tr>

              <tr class="">
                <td>
                  <div class="cell">21</div>
                </td>
                <td>
                  <div class="cell percent">100%</div>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="event-table">
            <thead>
              <tr>
                <th>
                  <div class="" style={{ color: "#b3122f" }}>
                    N° EVENTI
                  </div>
                </th>
                <th>
                  <div class="" style={{ color: "#000000" }}>
                    %
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <div class="cell">23</div>
                </td>
                <td>
                  <div class="cell percent">125%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">24</div>
                </td>
                <td>
                  <div class="cell percent">140%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">25</div>
                </td>
                <td>
                  <div class="cell percent">160%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">26</div>
                </td>
                <td>
                  <div class="cell percent">180%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">27</div>
                </td>
                <td>
                  <div class="cell percent">210%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">28</div>
                </td>
                <td>
                  <div class="cell percent">240%</div>
                </td>
              </tr>

              <tr>
                <td>
                  <div class="cell">29</div>
                </td>
                <td>
                  <div class="cell percent">270%</div>
                </td>
              </tr>

              <tr class="">
                <td>
                  <div class="cell">30</div>
                </td>
                <td>
                  <div class="cell percent">300%</div>
                </td>
              </tr>
            </tbody>
          </table>
          <style>
            {`
  /* CONTENITORE ESTERNO */
  .table-wrapper {
    width: 900px;      /* ← CAMBIA QUI */
    height: 420px;     /* ← CAMBIA QUI */
    padding: 2%;
    display: flex;
  }

  /* CARD INTERNA */
  .table-container {
    width: 100%;
    height: 100%;
    background: #000000;
    padding: 2%;
  }

  /* TABELLA */
  .event-table {
    width: 32.33333%;
    height: 100%;
    border-collapse: separate;
    table-layout: fixed;
    margin: 1%;
    background: #ffffff;

  }

  /* HEADER */
  .event-table thead th {
    text-align: center;
    color: #000000;
    font-weight: 800;
    height: 75%;
    margin: 10%;
  }

  /* CELLE */
  .event-table td {
  }

  /* CONTENUTO CELLA */
  .cell {
    text-align: center;
    font-weight: 700;
    background:  #ddd ;
    border-radius: 8px;
    height: 75%;
    margin: 0 10%;
    color: #b3122f;

  }

  .cell.percent {
    color: #000000;
  }


  .event-table tr.highlight .cell {
    background: transparent;
    color: #b3122f;
  }
`}
          </style>
        </div>
      </div>
    </>
  );
};

export default BonusTable;
